import {http} from '@/http'
import {Storage, Analytics} from '../../../core/Utils'
import {AnswerService} from "../../FinFit/Services";

const resource = "/api/auth";

export default {
  login(username, password) {
    return http.post(`${resource}/login/`, {email: username, password: password})
      .then(response => {
          this.storeUserCredentials(response.user);
          const userId = Storage.getUser().id
          const elapsedSeconds = Storage.getElapsedSeconds()
          const questionsAnswered = Storage.getAnswers()
          if (userId && elapsedSeconds && questionsAnswered) {
            AnswerService.saveQuiz(userId, questionsAnswered, elapsedSeconds)
              .then(() => {
                Storage.removeItemAnswers()
              })
          }
          return response
        }
      );
  },
  loginWithToken(token) {
    return http.post(`${resource}/refreshtoken/`, {refreshToken: token})
      .then(response => {
        const user = Storage.getUser()
        // get new access token
        user.token = response.user.token
        Storage.setUser(user)
        return user
      });
    },
    storeUserCredentials(credentials) {
        Storage.setUser(credentials)
        Analytics.loadUserId()
    },
    isValidAuthenticate(){
      let user = Storage.getUser();
      return Object.keys(user).length !== 0;
    },
    checkJWTtoken(token) {
        return http.post(`${resource}/token/verify/`, {token: token})
    },
    createUser(payload) {
        return http.post(`${resource}`, payload)
    },
    logout() {
        // remove all data from local storage (including user) to log out
        Storage.clearAll()
        // remove Google Analytics User ID
        Analytics.clearUserId()
    }
}
